import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Assets',
  components: {

  },
  props: {

  },
  emits: {
      
  },
})
export default class Assets extends Vue {
    
}
